import { apiErrorMessage } from '../../../../../shared/policies/api-error-message';
import { useToast } from '../../../../../shared/hooks/use-toast';
import { endAccessorialRate, type AccessorialRateView } from '../../../rate-cards.api';
import { todayIso } from '../../../policies/rate-line-status';

/** Ends a rate after today, at once (there is no approval step). It is a row action with no form, so a refusal is a toast. */
export function useEndAccessorialRate(onEnded: () => Promise<void>) {
  const toast = useToast();

  return async function end(rate: AccessorialRateView): Promise<void> {
    try {
      await endAccessorialRate(rate.id, { validTo: todayIso() });
      toast.success('Accessorial rate ended');
      await onEnded();
    } catch (err) {
      toast.error(apiErrorMessage(err) ?? 'Could not end the rate');
    }
  };
}
